import { makeAutoObservable } from 'mobx'
import { demo } from 'page/catalog/store/CatalogStore'
import { parseIntFinite } from 'util/number'

export class TimeoutStore {
  active = true
  timer = 0
  started = false
  private timeout: TimeoutId | null = null
  private readonly onClose: Function

  constructor(onClose: Function) {
    makeAutoObservable(this)
    this.onClose = onClose
  }

  start() {
    if (this.started) return
    this.started = true
    this.active = true
    this.touch()
  }

  stop() {
    this.started = false
    this.active = true
    this.clearTimeout()
    this.onClose()
  }

  cancel() {
    this.active = true
    if (!this.started) return
    this.touch()
  }

  touch() {
    if (!this.active) return
    this.setTimeout(this.onInactive.bind(this), this.inactive_timeout)
  }

  private onInactive() {
    this.active = false
    this.timer = Math.trunc(this.logout_timeout / 1000)
    this.setTimeout(this.onLogoutTick.bind(this), 1000)
  }

  private onLogoutTick() {
    this.timer = Math.max(0, this.timer - 1)
    if (this.timer > 0) this.setTimeout(this.onLogoutTick, 1000)
    else this.stop()
  }

  private clearTimeout() {
    clearTimeout(this.timeout ?? undefined)
  }

  private setTimeout(method: Function, timeout: number) {
    this.clearTimeout()
    this.timeout = setTimeout(method.bind(this), timeout)
  }

  private get inactive_timeout(): number {
    const debug = parseIntFinite(localStorage.getItem('debug_session_timeout'))
    if (debug) return debug
    const timeout = demo.optional?.product.inactive_timeout
    return timeout ? timeout * 1000 : 120_000
  }

  private get logout_timeout(): number {
    const timeout = demo.optional?.product.logout_timeout
    return timeout ? timeout * 1000 : 30_000
  }
}
